import { IconButton, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadOffIcon from "@mui/icons-material/FileDownloadOff";
import { PersistedRecording } from "types/PersistedRecording";
import { PersistedRecordingDownloadStatus } from "types/PersistedRecordingDownloadStatus";

export interface DownloadPersistedRecordingButtonProps {
    persistedRecording: PersistedRecording;
}

export function DownloadPersistedRecordingButton(
    props: DownloadPersistedRecordingButtonProps,
) {
    const isUnavailable =
        props.persistedRecording.status !==
        PersistedRecordingDownloadStatus.Completed;

    return (
        <Tooltip title="Download">
            <IconButton
                disabled={isUnavailable}
                onClick={() => {
                    const hiddenElement = document.createElement("a");
                    hiddenElement.href = props.persistedRecording.playbackUrl;
                    hiddenElement.target = "_blank";
                    hiddenElement.click();
                }}
            >
                {isUnavailable ? <FileDownloadOffIcon /> : <DownloadIcon />}
            </IconButton>
        </Tooltip>
    );
}
